import controller from './menu-toggle.controller';
import templateBase from './templates/menu-toggle-adaptative.view.html';


let MenuToggleComponent = {
  template: templateBase,
  controller,
  bindings : {
    shCtrl : '<',
    menu : '<'
  }
};



changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');

    if (response.MENUDROPDOWN.component == 'template_t3') {
        return templateT3;
    }else{
        return templateBase;
    }
}

export default MenuToggleComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/menu-toggle/menu-toggle.component.js
 **/